export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

export const DATETIME_FORMATS = {
  us: 'h:mm A, MM/DD/YYYY',
  eu: 'h:mm DD/MM/YYYY'
};

export const DATE_FORMATS = {
  us: 'MM/DD/YYYY',
  eu: 'DD.MM.YYYY'
};

export const TIME_FORMATS = {
  us: 'hh:mm A',
  eu: 'HH:MM:SS'
};
